import createIcon from '../../createIcon';

/**
 * @component @name DynamicForm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMjBWMTFIMTVWNEgyMkwyMCA5SDIyTDE3IDIwWk0xNSAxM1YyMEg0QzIuOSAyMCAyIDE5LjEgMiAxOFYxNUMyIDEzLjkgMi45IDEzIDQgMTNIMTVaTTYuMjUgMTUuNzVINC43NVYxNy4yNUg2LjI1VjE1Ljc1Wk0xMyA0VjExSDRDMi45IDExIDIgMTAuMSAyIDlWNkMyIDQuOSAyLjkgNCA0IDRIMTNaTTYuMjUgNi43NUg0Ljc1VjguMjVINi4yNVY2Ljc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DynamicForm = createIcon('DynamicForm', [
  [
    'path',
    {
      d: 'M17 20V11H15V4H22L20 9H22L17 20ZM15 13V20H4C2.9 20 2 19.1 2 18V15C2 13.9 2.9 13 4 13H15ZM6.25 15.75H4.75V17.25H6.25V15.75ZM13 4V11H4C2.9 11 2 10.1 2 9V6C2 4.9 2.9 4 4 4H13ZM6.25 6.75H4.75V8.25H6.25V6.75Z',
      key: '1yquza',
    },
  ],
]);

export default DynamicForm;
